import { Component } from '@angular/core';
import { BaseListComponent } from '../base-list/base-list.component';
import { DomSanitizer } from '@angular/platform-browser';
import { SecurityOperations } from 'src/app/core/security/security-operations';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { OpenModalService } from 'src/app/core/services/modal-services/open-modal.service';
import { PdfViewerModalService } from 'src/app/core/services/modal-services/pdf-viewer-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { TaskListService } from 'src/app/core/services/list-services/task-list.service';
import { TaskModel } from 'src/app/core/models/task/task.model';
import { Observable } from 'rxjs';
import { StrategyType } from 'src/app/core/enums/strategy-type-enum';
import { TaskModalService } from 'src/app/core/services/modal-services/task-modal.service';
import { AiApiService } from 'src/app/core/services/ai-api.service';

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.scss'],
  providers: [TaskListService]
})
export class TaskListComponent extends BaseListComponent{

  protected override searchPlaceHolderText: string = "Search by name or number";

  override listItemsObservable!: Observable<TaskModel[]>; 

  //set this one to create since we do not have a permission just for update right now - logic here being that for most cases until we implement update, anyone who is able to create invoices should be able to change them.   
  securityPermissionInvoiceUpdate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionCreateInvoice);

  constructor(
    protected aiApiService: AiApiService,
    protected taskModalService: TaskModalService,
    protected taskListService: TaskListService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override pdfModalService: PdfViewerModalService,
    protected override authMyFileService: AuthMyfileService,
    protected override openModalService: OpenModalService,
    protected override toasterNotificationService: ToasterNotificationService,
  ) {
    super(myFileApiService, sanitizer, pdfModalService, authMyFileService, toasterNotificationService, openModalService);
  }

  ngOnInit(): void {

    this.listItemsObservable = this.taskListService.resultItems$;
    this.total = this.taskListService.total$;
    this.isLoading = this.taskListService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.isLoadingVal = true;
      } else {
        this.isLoadingVal = false;
      }
    });
    this.unsubscribe.push(subscr);

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
    });
    this.unsubscribe.push(subscr2);
  }

  ngOnDestroy() {
    this.clearSearch(this.taskListService);
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  getType(type:StrategyType|undefined){
    if(type !== undefined){
      switch (type) {
        case StrategyType.Api: 
        return "Api"
        case StrategyType.Export: 
        return "Export"
        case StrategyType.Import: 
        return "Import"
        case StrategyType.Other: 
        return "Other"
        case StrategyType.PowerAutomate: 
        return "PowerAutomate"
        case StrategyType.Process: 
        return "Process"
        case StrategyType.Share: 
        return "Share"
      }
    }
    return 'Unknown';
  }

  executeOperation(id:string){
    if(id !== undefined){
      this.isLoadingVal = true;
      this.aiApiService.executeTask(id).subscribe((result)=>{
        this.isLoadingVal = false;
      })
    }
  }

  editTask(taskModel:TaskModel){
    this.taskModalService.openModal(taskModel);
  }

  createNewTask(){
    var newTaskModel = new TaskModel();
    this.taskModalService.openModal(newTaskModel);
  }

}
